module.exports = __webpack_public_path__ + "img/认证中心.b67a96ea.png";